export enum FailureType {
  ACESSÓRIOS_E_OUTROS = "Acessórios e outros",
  ALINHAMENTO_DE_CHASSIDIREÇÃO = "Alinhamento de chassi/direção",
  AMORTECEDORES_SUSPENSÃO = "Amortecedores suspensão",
  ATRITO_DO_CHICOTE_ELÉTRICO_COM_O_CORRUGADO = "Atrito do chicote elétrico com o corrugado",
  ATUALIZAÇÃO_DE_SOFTWARE = "Atualização de software",
  AÇÃO_DE_CAMPO = "Ação de campo",
  BARRA_DE_DIREÇÃO = "Barra de direção",
  BATERIA = "Bateria",
  BOMBA_DÁGUA = "Bomba d'água",
  BOMBA_DE_ALTA_PRESSÃO_DE_COMBUSTIVEL = "Bomba de alta pressão de combustível",
  BOMBA_DE_ÓLEO = "Bomba de óleo",
  BOMBA_DIREÇÃO_HIDRÁULICA = "Bomba direção hidráulica",
  CABEÇOTE = "Cabeçote",
  CAIXA_DE_DIREÇÃO = "Caixa de direção",
  CAIXA_DE_MARCHAS_ENTRA_EM_NEUTRO = "Caixa de marchas - entra em neutro",
  CAIXA_DE_MUDANÇA = "Caixa de mudança",
  CAMISA_DO_BLOCO = "Camisa do bloco",
  CAPTAÇÃO_DE_AR_ENTRADA_DE_ABRASIVO = "Captação de ar / entrada de abrasivo",
  CARDAN = "Cardan",
  CARROCERIA = "Carroceria",
  CATALISADOR_OBSTRUÍDO = "Catalisador obstruído",
  CATRACA_DE_FREIO = "Catraca de freio",
  CHASSI = "Chassi",
  COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO = "Combustível, gás de escape e arrefecimento",
  COMPRESSOR_DE_AR = "Compressor de ar",
  CONSUMO_DE_OLEO_LUBRIFICANTE_EM_EXCESSO = "Consumo de óleo lubrificante em excesso",
  CUICA_DE_FREIO = "Cuíca de freio",
  CÂMARA_DE_FREIO = "Câmara de freio",
  DESGASTE_DE_ANEIS_SINCRONIZADORES = "Desgaste de anéis sincronizadores",
  DESGASTE_DE_LUVA_DE_ENGATE_GP_E_GV = "Desgaste de luva de engate GP e GV",
  DESGASTE_DO_GARFO_DE_ENGATE = "Desgaste do garfo de engate",
  EIXO_S_CAME = "Eixo 'S' came",
  EIXO_DE_TRAÇÃO = "Eixo de tração",
  EIXO_E_CAIXA_DE_DIREÇÃO = "Eixo e caixa de direção",
  EIXO_TRASEIRO = "Eixo traseiro",
  EM_DIAGNOSE_00_ACESSÓRIOS_E_OUTROS = "Em diagnose - 0.0 Acessórios e outros",
  EM_DIAGNOSE_10_MOTOR = "Em diagnose - 1.0 Motor",
  EM_DIAGNOSE_100_REVISÃO = "Em diagnose - 10.0 Revisão",
  EM_DIAGNOSE_110_SOFTWARE = "Em diagnose - 11.0 Software",
  EM_DIAGNOSE_120_SINISTRO = "Em diagnose - 12.0 Sinistro",
  EM_DIAGNOSE_130_AÇÃO_DE_CAMPO = "Em diagnose - 13.0 Ação de campo",
  EM_DIAGNOSE_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO = "Em diagnose - 2.0 Combustível, gás de escape e arrefecimento (pós tratamento)",
  EM_DIAGNOSE_30_CAIXA_DE_MUDANÇA = "Em diagnose - 3.0 Caixa de mudança",
  EM_DIAGNOSE_40_EIXO_E_CAIXA_DE_DIREÇÃO = "Em diagnose - 4.0 Eixo e caixa de direção",
  EM_DIAGNOSE_50_EIXO_TRASEIRO = "Em diagnose - 5.0 Eixo traseiro",
  EM_DIAGNOSE_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "Em diagnose - 6.0 Sistema de freio e circuito pneumático",
  EM_DIAGNOSE_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA = "Em diagnose - 7.0 Sistema de alavanca (pedaleira e cabos de marcha)",
  EM_DIAGNOSE_80_CARROCERIA = "Em diagnose - 8.0 Carroceria",
  EM_DIAGNOSE_90_SISTEMA_ELÉTRICO = "Em diagnose - 9.0 Sistema elétrico",
  EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO = "Embreagem (incluindo sistema de acionamento)",
  EMBREAGEM_VISCOSA_HÉLICE = "Embreagem viscosa / hélice",
  EMBUCHAMENTO_MANGA_EIXO = "Embuchamento manga eixo",
  ENGATE_DE_MARCHAS = "Engate de marchas",
  FALTA_DE_LUBRIFICAÇÃO = "Falta de lubrificação",
  FREIO_MOTOR = "Freio motor",
  GELADEIRA = "Geladeira",
  INJETORES_DE_COMBUSTIVEL = "Injetores de combustível",
  LONA_DE_FREIO = "Lona de freio",
  MANGUEIRAS_TUBULAÇÕES = "Mangueiras / tubulações",
  MODIFICAÇÃOATUALIZAÇÃO_DE_PRODUTO = "Modificação/atualização de produto",
  MOLA_PNEUMÁTICA = "Mola pneumática",
  MOTOR = "Motor",
  MÓDULO_TCU = "Módulo TCU",
  OUTROS_10_MOTOR = "Outros - 1.0 Motor",
  OUTROS_100_REVISÃO = "Outros - 10.0 Revisão",
  OUTROS_110_SOFTWARE = "Outros - 11.0 Software",
  OUTROS_120_SINISTRO = "Outros - 12.0 Sinistro",
  OUTROS_130_AÇÃO_DE_CAMPO = "Outros - 13.0 Ação de campo",
  OUTROS_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO = "Outros - 2.0 Combustível, gás de escape e arrefecimento (pós tratamento)",
  OUTROS_30_CAIXA_DE_MUDANÇA = "Outros - 3.0 Caixa de mudança",
  OUTROS_40_EIXO_E_CAIXA_DE_DIREÇÃO = "Outros - 4.0 Eixo e caixa de direção",
  OUTROS_50_EIXO_TRASEIRO = "Outros - 5.0 Eixo traseiro",
  OUTROS_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "Outros - 6.0 Sistema de freio e circuito pneumático",
  OUTROS_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA = "Outros - 7.0 Sistema de alavanca (pedaleira e cabos de marcha)",
  OUTROS_80_CARROCERIA = "Outros - 8.0 Carroceria",
  OUTROS_90_SISTEMA_ELÉTRICO = "Outros - 9.0 Sistema elétrico",
  OUTROS_ACESSÓRIOS_E_OUTROS = "Outros - Acessórios e outros",
  PERDA_DE_POTÊNCIA = "Perda de potência",
  PINTURA_C_PROBLEMA_QUALIDADE = "Pintura c problema qualidade",
  PRESSÃO_LÍQ_ARREFECIMENTO_DO_MOTOR = "Pressão líq. arrefecimento do motor",
  PÓS_TRATAMENTO = "Pós-tratamento",
  QUEBRA_DA_ABRAÇADEIRA_TUBO_DE_ESCAPE_PÓS_TURBO = "Quebra da abraçadeira tubo de escape pós turbo",
  QUEBRA_DO_SUPORTE_DO_PARALAMA = "Quebra do suporte do paralama",
  RADIADOR = "Radiador",
  RASTREADOR = "Rastreador",
  REFORMA_ENTRE_SAFRA = "Reforma entre safra",
  REPARO = "Reparo",
  REPARO_DE_FUNILARIA_E_PINTURA = "Reparo de funilaria e pintura",
  RETENTORCUBOROLAMENTO = "Retentor/cubo/rolamento",
  RETRABALHO_CHASSI = "Retrabalho chassi",
  REVISÃO = "Revisão",
  REVISÃO_ACESSÓRIOS_E_OUTROS = "Revisão - Acessórios e outros",
  REVISÃO_VEICULO_DEMONSTRAÇÃO = "Revisão veiculo demonstração",
  ROLAMENTO_DE_RODA = "Rolamento de roda",
  ROTAÇÃO_DE_BRONZINACASQUILHO = "Rotação de bronzina/casquilho",
  SINISTRO = "Sinistro",
  SISTEMA_ABS = "Sistema ABS",
  SISTEMA_DE_ADMISSÃO_DE_AR = "Sistema de admissão de ar",
  SISTEMA_DE_ALIMENTAÇÂO_DE_COMBUSTIVEL = "Sistema de alimentação de combustível",
  SISTEMA_DE_ELEVAÇÃO_DE_EIXO = "Sistema de elevação de eixo",
  SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "Sistema de freio e circuito pneumático",
  SISTEMA_ELÉTRICO = "Sistema elétrico",
  SISTEMAMANGUEIRAS_DE_ARREFECIMENTO = "Sistema/mangueiras de arrefecimento",
  SOFTWARE = "Software",
  TIRANTE_V = "Tirante V",
  TROCA_RELAÇÃO_DIFERENCIAL = "Troca relação diferencial",
  TUBO_DE_ADMISSÃO_DE_AR_COM_CORROSÃO = "Tubo de admissão de ar com corrosão",
  TUBOS_SISTEMA_DE_ESCAPAMENTO = "Tubos sistema de escapamento",
  TURBOCOMPRESSOR = "Turbocompressor",
  VAZAMENTO_DE_LUBRIFICANTE_PELA_PTO = "Vazamento de lubrificante pela PTO",
  VAZAMENTO_DE_ÓLEO_LUBRIFICANTE = "Vazamento de óleo lubrificante",
}

export enum FailureMode {
  ACESSÓRIOS_E_OUTROS = "0.0 Acessórios e outros",
  MOTOR = "1.0 Motor",
  EMBREAGEM_EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO = "1.1 Embreagem (embreagem, incluindo sistema de acionamento)",
  REVISÃO = "10.0 Revisão",
  SOFTWARE = "11.0 Software",
  SINISTRO = "12.0 Sinistro",
  AÇÃO_DE_CAMPO = "13.0 Ação de campo",
  COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO = "2.0 Combustível, gás de escape e arrefecimento (pós tratamento)",
  PÓSTRATAMENTO = "2.1 Pós-tratamento",
  CAIXA_DE_MUDANÇA = "3.0 Caixa de mudança",
  EIXO_E_CAIXA_DE_DIREÇÃO = "4.0 Eixo e caixa de direção",
  SISTEMA_DE_SUSPENSÃO_DIANTEIRA = "4.1 Sistema de suspensão dianteira",
  SISTEMA_DE_DIREÇÃO = "4.2 Sistema de direção",
  EIXO_TRASEIRO = "5.0 Eixo traseiro",
  ROLAMENTO_DE_RODA = "5.1 Rolamento de roda",
  SISTEMA_DE_SUSPENSÃO_TRASEIRA = "5.2 Sistema de suspensão traseira",
  SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "6.0 Sistema de freio e circuito pneumático",
  SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA = "7.0 Sistema de alavanca (pedaleira e cabos de marcha)",
  CARROCERIA = "8.0 Carroceria",
  CHASSI = "8.1 Chassi",
  SISTEMA_ELÉTRICO = "9.0 Sistema elétrico",
}
